import { useContent } from "@/hooks/useContent";
import useUsers from "@/hooks/useUsers";

const EmptyStateGreeting = () => {
  const { t } = useContent();
  const { useQueryMe } = useUsers();
  const me = useQueryMe();

  const firstName = me.data?.firstName || "";

  return (
    <div className="flex flex-col items-center text-center">
      <h1 className="text-4xl font-bold mb-2 text-foreground">
        {firstName ? `Hej, ${firstName}` : "Hej"}
      </h1>
      <h2 className="text-xl font-semibold mb-2 text-foreground">
        {t("chat.emptyState.greeting.headline")}
      </h2>
      <p className="text-muted-foreground text-sm">
        {t("chat.emptyState.greeting.subtitle")}
      </p>
    </div>
  );
};

export default EmptyStateGreeting;
